import React from "react";
import { Link } from "react-router-dom";

import fomralman from "../assets/images/team/formal-man.png";
import sebghatullah from "../assets/images/team/sebghatullah.jpg";
import jonathan from "../assets/images/team/jonathan.png";
import abraham from "../assets/images/team/abraham.png";
import developer from "../assets/images/team/developer.jpg";
import team1 from "../assets/images/team/01.jpg";
import formallady from "../assets/images/team/formallady.png";
import sundar from "../assets/images/team/sundarsingh.jpg";
import verified_client from "../assets/images/team/verified_client.png";


export default function Clients() {
  const testimonials = [
    {
      image: fomralman,
      name: "Tan Han Sing",
      title: "Founder of Tueetor (AWS)",
      desc: "Gohar is possibly one of the the best, if not the best freelancer on Fiverr I have worked with. Honest and diligent and proactive. They are all attributes any service provider should exhibit and yet so difficult to find these days.",
    },
    {
      image: sebghatullah,
      name: "Sebghatullah",
      title: "Founder of AZ Services",
      desc: "I want to commend Ali for his exceptional work on my project. He was highly cooperative, addressing my requirements step by step. He is an invaluable asset, consistently exceeding expectations. I'm grateful to have him on the team!. Highly recommend!",
    },
    {
      image: abraham,
      name: "Christopher Abraham SPMIIM",
      title: "PMIIM Africa",
      desc: "There are so many things I had to do with my old software and Gohar helped me out tremendously in getting everything sorted and running smoothly. Excellent Job done, Good communication, Hardworking and dedicated to quality delivery RECOMMENDED!",
    },     
    {
      image: sundar,
      name: "Sundar Singh",
      title: "Founder | Yoga & Meditation Teacher",
      desc: "Working with Gohar has been a great experience. He is humble, cooperative, and truly dedicated to delivering quality results. We were especially impressed by his design skills, which made our website both visually appealing and user-friendly, while also ensuring excellent speed and performance. Overall, the collaboration was smooth, enjoyable, and exceeded our expectations — we absolutely love our website!",
    },
    {
      image: formallady,
      name: "Bushra Barakah",
      title: "Project Coordinator (M5AZN)",
      desc: "Working with Gohar as our Front-End Designer for M5azn has been an excellent experience. He has a sharp eye for detail, a strong sense of design, and the ability to turn concepts into clean, user-friendly interfaces. Gohar was always responsive, collaborative, and quick to implement changes without compromising quality. His contribution added real value to our platform, and I highly recommend him to anyone looking for a talented and reliable front-end designer",
    },
    {
      image: developer,
      name: "Andresilich",
      title: "Senior Software Expert",
      desc: "I had the pleasure of collaborating with Gohar during a high-pressure crash project. His ability to troubleshoot and provide innovative solutions was invaluable. With his expertise and support, we navigated challenges effectively and delivered a successful outcome. I highly recommend Gohar for any software development needs!",
    },    
    {
      image: verified_client,
      name: "r_jmhoov",
      title: "Verified Client, Fiverr",
      desc: "Absolutely amazing experience! Gohar is a truly creative, talented, and hard-working professional designer who goes above and beyond. He carefully listened to my vision and delivered a design that exceeded all expectations — unique, polished, and exactly what I needed. Having worked with many designers over the years, I can confidently say he stands out as one of the very best. Exceptional work, and I couldn’t be more pleased with the results!",
    },   
    {
      image: team1,
      name: "A. Esmail",
      title: "Manager at Design Agency",
      desc: "Gohar's expertise is a game-changer! His innovative solutions and collaborative spirit helped elevate our projects to new heights. A true professional who delivers results every time! I highly recommend Gohar for any software development or collaborative projects!",
    },   
    {
      image: jonathan,
      name: "Jonathan Miller",
      title: "Entrepreneur | Advisor | Investor",
      desc: "Gohar is easy to work with. He gives fair prices for the gigs, he responds relatively fast, and he completes the tasks quickly. Summary: - Good pricing - Fast work - Easy to speak with",
    },
  ];

  return (
    <div className="container relative lg:mt-24 mt-16">
      <div className="grid grid-cols-1 pb-6 text-center">
        <h3 className="mb-4 md:text-2xl text-xl font-medium">
          Client Experiences
        </h3>

        <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
          Check out what my clients have to say about our collaborations. Their
          insights showcase the impact of my work and the relationships we've
          built
        </p>
      </div>

      <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 mt-6">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className="rounded-xl shadow dark:shadow-gray-800 p-6 bg-white dark:bg-slate-900"
          >
            <div className="flex items-center pb-6 border-b border-gray-100 dark:border-gray-800">
              <img
                src={item.image}
                className="h-14 w-14 rounded-full shadow dark:shadow-gray-800"
                alt={item.name}
              />

              <div className="ps-3">
                <Link
                  to=""
                  className="text-[16px] font-medium hover:text-orange-500 duration-500"
                >
                  {item.name}
                </Link>
                <p className="text-slate-400 dark:text-white/60">
                  {item.title}
                </p>
              </div>
            </div>

            <div className="mt-6">
              <p className="text-slate-400 dark:text-white/60">{item.desc}</p>
              <ul className="list-none mb-0 text-amber-400 mt-2">
                <li className="inline">
                  <i className="mdi mdi-star"></i>
                </li>
                <li className="inline">
                  <i className="mdi mdi-star"></i>
                </li>
                <li className="inline">
                  <i className="mdi mdi-star"></i>
                </li>
                <li className="inline">
                  <i className="mdi mdi-star"></i>
                </li>
                <li className="inline">
                  <i className="mdi mdi-star"></i>
                </li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
